import {
  CUSTOM_RANGE,
  FOUR_WEEKS,
  ONE_DAY,
  ONE_MONTH,
  ONE_WEEK
} from "src/blitz/DateRange/constant"
import { t } from "src/translations/help"

export const MAX_DATA_CELLS_QUANTITY = 2500000
export const DATA_INTERVAL_MINUTES = 15
export const RAW_DATA = "raw-data"
export const EXCEPTION_REPORT = "exception-history"
export const CHILLER_REPORT = "chiller-history"
export const AHU_REPORT = "ahu-history"
export const ALARMS_AND_EVENTS_REPORT = "alarms-and-events"
export const DIGITAL_INSPECTION_REPORT_VRF = "vrf-digital-inspection"
export const DIGITAL_INSPECTION_REPORT = "digital-inspection"
export const TRS_REPORT = "trs-report"

export const SELECT_ALL = [
  {
    title: "All",
    value: "all",
    type: "button"
  }
]

export const OPTION_ONE_MONTH = {
  title: "1 Month",
  value: ONE_MONTH,
  type: "button"
}
export const OPTION_ONE_DAY = {
  title: t("common.oneDay"),
  value: ONE_DAY,
  type: "button"
}
export const OPTION_ONE_WEEK = {
  title: t("common.oneWeek"),
  value: ONE_WEEK,
  type: "button"
}

export const OPTION_FOUR_WEEKS = {
  title: t("common.fourWeeks"),
  value: FOUR_WEEKS,
  type: "button"
}

export const OPTION_CUSTOM = {
  title: t("common.customRange"),
  value: CUSTOM_RANGE,
  type: "button"
}

export const trsTimePeriodOptions = [
  {
    title: "One Day",
    value: ONE_DAY,
    type: "button"
  },
  {
    title: "One Week",
    value: ONE_WEEK,
    type: "button"
  },
  {
    title: "Four Week",
    value: FOUR_WEEKS,
    type: "button"
  },
  {
    title: "One Month",
    value: ONE_MONTH,
    type: "button"
  },
  {
    title: "Custom",
    value: CUSTOM_RANGE,
    type: "button"
  }
]

export const defaultTimePeriodOptions = [
  OPTION_ONE_DAY,
  OPTION_ONE_WEEK,
  OPTION_FOUR_WEEKS,
  OPTION_CUSTOM
]

export const REPORT_STATE = {
  url: "",
  retryCount: 0
}

export const IsMultipleSingleFormat = "mxlsx"
export const NONE = "None"
export const CHARACTERISTIC = "Characteristic"
export const LOAD_VALVE = "LoadValve"
export const VAV_BOX = "VAV-BOX"

export const STANDALONE = "Standlone"

export const LANG_ENGLISH = "en"
export const LANG_FRENCH = "fr-CA"
export const IMPERIAL_MEASURE = "IP"
export const METRIC_MEASURE = "SI"
export const CHILLER = "Chiller"
export const AHU = "AHU"
export const BOILER = "Boiler"
export const HP_CHILLER = "HeatPumpChiller"

export const OTHER_LANG_CODE: any = {
  EN_GB: "en-gb",
  AR: "ar",
  BG: "bg",
  HR: "hr",
  CS: "cs",
  DA: "da",
  NL: "nl",
  ET: "et",
  FI: "fi",
  FR: "fr",
  FR_CA: "fr-CA",
  DE: "de",
  EL: "el",
  HE: "he",
  HU: "hu",
  IT: "it",
  LV: "lv",
  LT: "lt",
  NO: "no",
  PL: "pl",
  PT: "pt",
  PT_PT: "pt-PT",
  RO: "ro",
  RU: "ru",
  SK: "sk",
  SL: "sl",
  ES: "es",
  ES_MX: "es-MX",
  SV: "sv",
  TR: "tr",
  ZH: "zh",
  ZH_TW: "zh-TW",
  TH: "th",
  JA: "ja",
  KO: "ko",
  VI: "vi"
}

export const reportTimePeriodOptions: Record<string, any[]> = {
  [CHILLER_REPORT]: [OPTION_ONE_MONTH],
  [AHU_REPORT]: [OPTION_ONE_MONTH],
  [TRS_REPORT]: trsTimePeriodOptions,
  [DIGITAL_INSPECTION_REPORT]: [
    OPTION_ONE_WEEK,
    OPTION_FOUR_WEEKS,
    OPTION_CUSTOM
  ],
  [RAW_DATA]: defaultTimePeriodOptions,
  [EXCEPTION_REPORT]: defaultTimePeriodOptions,
  [ALARMS_AND_EVENTS_REPORT]: defaultTimePeriodOptions
}

export const systemOfMeasureOptions: any = [
  {
    title: "Imperial(IP)",
    value: IMPERIAL_MEASURE,
    type: "button"
  },
  {
    title: "Metric(SI)",
    value: METRIC_MEASURE,
    type: "button"
  }
]

export const languageOptions: any = [
  {
    title: "English",
    value: LANG_ENGLISH,
    type: "button"
  },
  {
    title: "English UK",
    value: OTHER_LANG_CODE.EN_GB,
    type: "button"
  },
  {
    title: "Arabic",
    value: OTHER_LANG_CODE.AR,
    type: "button"
  },
  {
    title: "Bulgarian",
    value: OTHER_LANG_CODE.BG,
    type: "button"
  },
  {
    title: "Croatian",
    value: OTHER_LANG_CODE.HR,
    type: "button"
  },
  {
    title: "Czech",
    value: OTHER_LANG_CODE.CS,
    type: "button"
  },
  {
    title: "Danish",
    value: OTHER_LANG_CODE.DA,
    type: "button"
  },
  {
    title: "Dutch", //"Nederlands",
    value: OTHER_LANG_CODE.NL,
    type: "button"
  },
  {
    title: "Estonian",
    value: OTHER_LANG_CODE.ET,
    type: "button"
  },
  {
    title: "Finnish",
    value: OTHER_LANG_CODE.FI,
    type: "button"
  },
  {
    title: "French", //"Français",
    value: OTHER_LANG_CODE.FR,
    type: "button"
  },
  {
    title: "French (Canada)", //"Français(Canada)",
    value: OTHER_LANG_CODE.FR_CA,
    type: "button"
  },
  {
    title: "German", //"Deutsch",
    value: OTHER_LANG_CODE.DE,
    type: "button"
  },
  {
    title: "Greek",
    value: OTHER_LANG_CODE.EL,
    type: "button"
  },
  {
    title: "Hebrew", //עברית
    value: OTHER_LANG_CODE.HE,
    type: "button"
  },
  {
    title: "Hungarian", //"Magyar",
    value: OTHER_LANG_CODE.HU,
    type: "button"
  },
  {
    title: "Italian", //"Italiana",
    value: OTHER_LANG_CODE.IT,
    type: "button"
  },
  {
    title: "Latvian",
    value: OTHER_LANG_CODE.LV,
    type: "button"
  },
  {
    title: "Lithuanian",
    value: OTHER_LANG_CODE.LT,
    type: "button"
  },
  {
    title: "Norwegian",
    value: OTHER_LANG_CODE.NO,
    type: "button"
  },
  {
    title: "Polish",
    value: OTHER_LANG_CODE.PL,
    type: "button"
  },
  {
    title: "Portuguese (Brazil)", //"Português(Brasil)",
    value: OTHER_LANG_CODE.PT,
    type: "button"
  },
  {
    title: "Portuguese (Portugal)", //"Português(Portugal)",
    value: OTHER_LANG_CODE.PT_PT,
    type: "button"
  },
  {
    title: "Romanian",
    value: OTHER_LANG_CODE.RO,
    type: "button"
  },
  {
    title: "Russian",
    value: OTHER_LANG_CODE.RU,
    type: "button"
  },
  {
    title: "Slovak",
    value: OTHER_LANG_CODE.SK,
    type: "button"
  },
  {
    title: "Slovenian",
    value: OTHER_LANG_CODE.SL,
    type: "button"
  },
  {
    title: "Spanish", //"Española",
    value: OTHER_LANG_CODE.ES,
    type: "button"
  },
  {
    title: "Spanish (Mexico)", //"Español (México)",
    value: OTHER_LANG_CODE.ES_MX,
    type: "button"
  },
  {
    title: "Swedish",
    value: OTHER_LANG_CODE.SV,
    type: "button"
  },
  {
    title: "Turkish",
    value: OTHER_LANG_CODE.TR,
    type: "button"
  },
  {
    title: "Chinese (Simplified)",
    value: OTHER_LANG_CODE.ZH,
    type: "button"
  },
  {
    title: "Chinese (Traditional)",
    value: OTHER_LANG_CODE.ZH_TW,
    type: "button"
  },
  {
    title: "Thailand",
    value: OTHER_LANG_CODE.TH,
    type: "button"
  },
  {
    title: "Japanese",
    value: OTHER_LANG_CODE.JA,
    type: "button"
  },
  {
    title: "Korean",
    value: OTHER_LANG_CODE.KO,
    type: "button"
  },
  {
    title: "Vietnamese",
    value: OTHER_LANG_CODE.VI,
    type: "button"
  }
]

// Raw Data report

export const DYNAMIC_EQUIPMENT_TYPES = [CHILLER, BOILER, HP_CHILLER]

export const EMPTY_EQUIPMENT_TYPE = { label: "", value: "" }

interface PreSelectedEquipTypeArgs {
  isBuildingLevel: boolean
  reportValue: string
  equipmentType?: string
  equipmentFamily?: string
  hasHpChillerPermission: boolean
}

export const getPreSelectedEquipType = ({
  isBuildingLevel,
  reportValue,
  equipmentType,
  equipmentFamily,
  hasHpChillerPermission
}: PreSelectedEquipTypeArgs) => {
  if (isBuildingLevel) return EMPTY_EQUIPMENT_TYPE
  if (reportValue === CHILLER_REPORT) {
    return hasHpChillerPermission && equipmentType === HP_CHILLER
      ? { label: equipmentFamily, value: HP_CHILLER }
      : { label: CHILLER, value: CHILLER }
  }
  if (!equipmentType) return EMPTY_EQUIPMENT_TYPE
  return { label: equipmentFamily, value: equipmentType }
}

